const personalizationTags = [
	{
		label: `Unsubscribe Link`,
		title: `Unsubscribe Link`,
		value: `#unsubscribeLink#`,
	},
	{
		label: `Update Preferences Link`,
		title: `Update Preferences Link`,
		value: `#updatePreferences#`,
	},
	{
		label: `Update Profile Link`,
		title: `Update Profile Link`,
		value: `#updateProfileLink#`,
	},
	{
		label: `Forward to a Friend Link`,
		title: `Forward to a Friend Link`,
		value: `#forwardToFriendLink#`,
	},
	{
		label: `Double Opt-in Verification Link`,
		title: `Double Opt-in Verification Link`,
		// value: '<a href="#VerificationLink#">Verification Link</a>',
		value: '#VerificationLink#',
	},
	{
		label: `Account VAT`,
		title: `Account VAT`,
		value: `#account:vat#`,
	},
	{
		label: `Account Email`,
		title: `Account Email`,
		value: `#account:email#`,
	},
	{
		label: `Account Address`,
		title: `Account Address`,
		value: `#account:address#`,
	},
	{
		label: `Account Company`,
		title: `Account Company`,
		value: `#account:company#`,
	},
	{
		label: `Current Date and Time`,
		title: `Current Date and Time`,
		value: `#datetime#`,
	},
	{
		label: `Recipient Name`,
		title: `Recipient Name`,
		value: `#recipient:name#`,
	},
	{
		label: `Recipient Email`,
		title: `Recipient Email`,
		value: `#recipient:email#`,
	},
	{
		label: `Recipient Preferences`,
		title: `Recipient Preferences`,
		value: `#recipient:preferences#`,
	},
	{
		label: `Recipient Mobile`,
		title: `Recipient Mobile`,
		value: `#recipient:mobile#`,
	},
	{
		label: `This email was sent to`,
		title: `This email was sent to`,
		value: `#emailSentTo#`,
	},
	{
		label: `View in Browser`,
		title: `View in Browser`,
		value:
			'<a href="http://#trackingDomain#/show_campaign/#campaign:key#/#recipient:key#/#ab#"><span class="custom-style-link">View in Browser</span></a>',
	},
];

export const RSSOnlyTags = [
	{
		label: 'RSS Title',
		value: '#rss:title#',
	},
	{
		label: 'RSS Summary',
		value: '#rss:summary#',
	},
];

export const HtmlOnlyTags = [
	{
		label: 'Page Title',
		value: '#page:title#',
	},
	{
		label: 'Page Description',
		value: '#page:description#',
	},
];

export default personalizationTags;
